module.exports = __webpack_public_path__ + "media/31.0954b89d.ogg";